export default __webpack_public_path__ + "static/media/plan-quickstart.f4fc06c5.svg";